<div odxLayout="flex gap-none" id="project-information" class="flex-column h-100 overflow-hidden">
  <odx-area-header>
    <div class="area-header-title-row">
      <h5 class="odx-title-5" i18n="@@projectInformation.header" data-testid="projectInformation.header">Projektinformationen</h5>
      @if ((isMobile$ | async) === true) {
        <odx-action-group>
          <button odxButton [odxDropdown]="content" [odxDropdownOptions]="dropdownOptions" class="dropdown-trigger">
            <odx-icon name="more" size="medium" />
          </button>
        </odx-action-group>
      }
    </div>
    <odx-area-header-content class="desktop-only">
      @if ((isReadOnlyUser$ | async) === false) {
        <!-- Desktop: show switch and edit button in header -->

        @if (isOpportunityLinkVisible()) {
          <odx-action-group>
            <button odxButton (click)="openLink()">
              <odx-icon name="link-external" size="medium" alignleft></odx-icon>
              <span i18n="@@crmproject.btn.openCRMOpportunity">CRM Opportunity</span>
            </button>
          </odx-action-group>
        }
        @if (isShowPricesVisible()) {
          <form [formGroup]="switchForm" class="switch desktop-only">
            <odx-switch
              formControlName="switch"
              i18n="@@projectInformation.switch.showPrices.label"
              data-testid="projectInformation.switch.showCost"
              >Preise anzeigen</odx-switch
            >
          </form>
        }
        <odx-action-group class="desktop-only edit-button-action-group">
          <button odxButton variant="primary" (click)="toggleEdit()" [disabled]="(hasWritePermission$ | async) === false">
            <odx-icon [name]="editEnabled ? 'save' : 'edit'" size="medium" alignleft></odx-icon>
            @if (!editEnabled) {
              <span i18n="@@global.edit">Bearbeiten</span>
            } @else {
              <span i18n="@@global.save">Speichern</span>
            }
          </button>
        </odx-action-group>
      }
    </odx-area-header-content>
  </odx-area-header>
  @if ((isReadOnlyUser$ | async) === false) {
    <div class="header-actions mobile-only">
      @if (isShowPricesVisible()) {
        <form [formGroup]="switchForm" class="switch">
          <odx-switch
            formControlName="switch"
            i18n="@@projectInformation.switch.showPrices.label"
            data-testid="projectInformation.switch.showCost"
            >Preise anzeigen</odx-switch
          >
        </form>
      }
      <button
        odxButton
        variant="primary"
        class="edit-button"
        (click)="toggleEdit()"
        [disabled]="(hasWritePermission$ | async) === false"
      >
        <odx-icon [name]="editEnabled ? 'save' : 'edit'" size="medium" alignleft></odx-icon>
        @if (!editEnabled) {
          <span i18n="@@global.edit">Bearbeiten</span>
        } @else {
          <span i18n="@@global.save">Speichern</span>
        }
      </button>
    </div>
  }
  <div odxLayout="gap-none" class="flex-scroll">
    <div odxLayout="grid 12 4@tablet">
      @if (templateFields(); as templateFields) {
        <app-project-form
          [isReadonly]="!editEnabled"
          [templateFields]="templateFields"
          [projectSignal]="projectSignal()"
          [clearFormSignal]="clearFormSignal()"
          [(isWriteable)]="isWriteable"
          #projectFormComponent
        ></app-project-form>
      }
      <div>
        <app-customer-form [isReadonly]="!editEnabled" #customerFormComponent></app-customer-form>

        @if (isGoodsRecipientInformationVisible()) {
          <app-goods-recipient-form
            [isReadonly]="!editEnabled"
            [projectSignal]="projectSignal()"
            (goodsRecipientFormEmitter$)="goodsRecipientForm = $event"
            [template]="templateFields()?.details?.goodsRecipient ?? {}"
          ></app-goods-recipient-form>
        }
      </div>
      <app-contact-person-form [isReadonly]="!editEnabled" #contactPersonFormComponent></app-contact-person-form>
    </div>
  </div>
</div>
<ng-template #content>
  <odx-action-group class="flex-column menu-items">
    <button
      odxButton
      variant="secondary"
      [odxTooltip]="copyProjectLinkTooltip"
      (click)="copyProjectLink()"
      class="mobile-copy-share-link-btn"
    >
      <odx-icon name="copy-content" size="medium" alignleft></odx-icon>
      <span i18n="@@project.btn.shareLink">Teilbaren Link kopieren</span>
    </button>
    @if (isOpportunityLinkVisible()) {
      <button odxButton variant="secondary" (click)="openLink()">
        <odx-icon name="link-external" size="medium" alignleft></odx-icon>
        <span i18n="@@crmproject.btn.openCRMOpportunity">CRM Opportunity</span>
      </button>
    }
  </odx-action-group>
</ng-template>
